import React from 'react';

const Dater =({date})=>{
    const DATE_OPTIONS = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    return <span>{(new Date(date)).toLocaleDateString('en-US', DATE_OPTIONS)}</span>
}

export default Dater;